module.exports = __webpack_public_path__ + "fonts/bb1e4dc.woff";